import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CmpsFocusLabelActionComponent } from './focus-label-action.component';
import { CmpsFocusLabelComponent } from './focus-label.component';

@NgModule({
    declarations: [CmpsFocusLabelComponent, CmpsFocusLabelActionComponent],
    imports: [CommonModule],
    exports: [CmpsFocusLabelComponent, CmpsFocusLabelActionComponent],
})
export class CmpsFocusLabelModule {}
